// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__jXw_J","spinner":"loader_spinner__vIyMy"};